/** How many modal dialogs are open: everything behind them is inert, so toasts there must not offer buttons. */
import { signal } from '@preact/signals';

/** The number of open `Modal`s. */
export const openModals = signal(0);
